import {UI} from "../../../../../../../stem-core/src/ui/UIBase";

import {ConfirmationModal} from "../../../../../../ui/ConfirmationModal";
import {Messages} from "../../../../../../Messages";
import {wrapInSpinner} from "../../../../../../../core/ui/LoadingSpinner.jsx";
import {SubscriptionStore} from "../../../../../../../client/state/SubscriptionStore";
import {apiDeleteAddress, UserAddressStore} from "../../../../../../../client/state/UserAddressStore";
import {autoredraw} from "../../../../../../../stem-core/src/decorators/AutoRedraw";


@autoredraw(SubscriptionStore, UserAddressStore)
export class DeleteAddressModal extends ConfirmationModal {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.deleteAddressTitle,
            cancelLabel: Messages.close,
            confirmLabel: Messages.removeAddress,
            description: Messages.deleteAddressDescription(this.options.address.toString()),
            confirmAction: () => this.deleteAddress(),
            address: null,
        };
    }

    @wrapInSpinner
    async deleteAddress() {
        this.hide();
        await apiDeleteAddress(this.options.address.id);
    }
}
